module.exports = __webpack_public_path__ + "static/media/readly_background.b9602f59.jpg";